export type DateFormatStyle = 'dot' | 'long';

const MONTHS_SHORT = [
  'янв.',
  'февр.',
  'мар.',
  'апр.',
  'мая',
  'июн.',
  'июл.',
  'авг.',
  'сент.',
  'окт.',
  'нояб.',
  'дек.',
];

export const getDateFormatStyle = (): DateFormatStyle => {
  try {
    const user = JSON.parse(sessionStorage.getItem('avia_profile') || '{}');
    return user?.date_format === 'long' ? 'long' : 'dot';
  } catch {
    return 'dot';
  }
};

const parseParts = (dateStr: string) => {
  const raw = String(dateStr).slice(0, 10);
  const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);

  if (match) {
    return {
      year: Number(match[1]),
      month: Number(match[2]),
      day: Number(match[3]),
    };
  }

  const date = new Date(dateStr);
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
  };
};

export const DateFormat = (
  dateStr: string,
  style: DateFormatStyle = getDateFormatStyle()
): string => {
  const { year, month, day } = parseParts(dateStr);

  if (style === 'long') {
    return `${day} ${MONTHS_SHORT[month - 1]} ${year} г.`;
  }

  const dd = String(day).padStart(2, '0');
  const mm = String(month).padStart(2, '0');
  return `${dd}.${mm}.${year}`;
};
